import { html } from 'lit';
import componentStyles from './caption.css.lit.ts';

import { OutlineElement } from '../../base/outline-element/outline-element.ts';
export default class Caption extends OutlineElement {
  static styles = [super.styles, componentStyles];

  render() {
    return html`<span class="caption"><slot></slot></span>`;
  }
}
customElements.define('hf-caption', Caption);
